
import { defineComponent } from 'vue';
import router from '@/router';

export default defineComponent({
  name: 'RecursoEmBreve',
  components: {

  },
  setup() {
    function voltar() {
      router.back();
    }

    return {
      voltar,
    };
  },
});
